import { environment } from './../../../environments/environment';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { StorageService } from "app/@core/services/storage.service";
import { saveAs } from 'file-saver';

@Injectable()
export class BaseService {
    private readonly STORAGE_KEY = 'table-settings';
    reloadCoulmn = new Subject();
    gridCount = new Subject();
    tableData = new Subject();
    tableData$ = this.tableData.asObservable();
    public filterSelect2Options = [];

    // ------------------------- Newly added for preset -------------------------
    gettingResponse: any;
    presetNameArr: any = [];
    presetNameArrDefault: any = [];
    columnsData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    columnsData$: Observable<any> = this.columnsData.asObservable();
    columnPresetDefault: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    columnPresetDefault$: Observable<any> = this.columnPresetDefault.asObservable();
    setData(data: string) {
        this.tableData.next(data);
    }

    getTableData(): Observable<any> {
        return this.tableData.asObservable();
    }

    constructor(
        private http: HttpClient,
        private spinner: NgxSpinnerService,
        public storageService: StorageService

    ) { }

    private getIsViewKey(pageReference: string): string {
        return `${pageReference}-isViewBool`;
    }

    private getJsonColumnDataKey(pageReference: string): string {
        return `${pageReference}-jsonColumnData`;
    }

    public sendForgotPassword(url): Observable<any> {
        return this.http.post(environment.APIURL + url, {});
    }

    public postRequest(url, body): Observable<any> {
        const tableSettingKey = localStorage.getItem('tableSettingKey');
        let isLoginCall = url.includes('login')
        if (!isLoginCall) {
            // localStorage.removeItem(tableSettingKey);
            let parseData = JSON.stringify(body);
            localStorage.setItem(tableSettingKey, parseData);
        }
        return this.http.post(environment.APIURL + url, body);
    }

    public getRequest(URL: any): Observable<any> {
        return this.http.get(environment.APIURL + URL);
    }

    public putRequest(url, body): Observable<any> {
        return this.http.put(environment.APIURL + url, body);
    }

    public removeRequest(url, UserId): Observable<any> {
        url = url+ `?UserId=${UserId}`
        return this.http.delete(environment.APIURL + url);
    }

    public exportExcel(URL: any, postData): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post(environment.APIURL + URL, postData, { headers, responseType: 'blob' })
    }

    public importExcel(URL: any, postData): Observable<any> {
        return this.http.post(environment.APIURL + URL, postData)
    }

    public getMapData(PageNumber, assetType = 0, assetList): Observable<any> {
        const companyId = this.storageService.getCompanyID();
        const optionalPageSize: number = 200;
        // const url = `MapData?CompanyId=${companyId}&PageNumber=${PageNumber}&assetType=${assetType}&pageSizeOptional=${optionalPageSize}`
        const url = `MapData`
        let obj = {
            "companyId": companyId,
            "assetType": assetType,
            "pageNumber": PageNumber,
            "pageSizeOptional": optionalPageSize,
            "assetList": assetList
          }
        return this.http.post(environment.APIURL + url, obj);
    }

    userId = localStorage.getItem('userId')

    public getTableSettings1(pageReference): Observable<any> {
        const url = `filter?userId=${this.userId}&page=${pageReference}`;
        return this.http.get(environment.APIURL + url);
    }


     getTableSettings(pageReference, isHardReload): Observable<any> {
        const scopedIsView = localStorage.getItem(this.getIsViewKey(pageReference));
        const fallbackIsView = localStorage.getItem("isViewBool");
        const isViewBool: any = scopedIsView !== null ? scopedIsView : fallbackIsView;

        const scopedJsonColumns = localStorage.getItem(this.getJsonColumnDataKey(pageReference));
        const fallbackJsonColumns = localStorage.getItem("jsonColumnData");
        const jsonColumnData: any = scopedJsonColumns !== null ? scopedJsonColumns : fallbackJsonColumns;

        let isView = false;
        let jsonColumnDataGet: any = undefined;

        if (isViewBool && isViewBool !== "null") {
            try {
                isView = JSON.parse(isViewBool);
            } catch {
                isView = false;
            }
        }

        if (jsonColumnData && jsonColumnData !== "null") {
            try {
                jsonColumnDataGet = JSON.parse(jsonColumnData);
            } catch {
                jsonColumnDataGet = undefined;
            }
        }

        const cachedData = localStorage.getItem(pageReference + '-' + this.STORAGE_KEY);
        let userType = localStorage.getItem("userType");
        let userId: any;
            userId = localStorage.getItem("userId");
        
        const companyId = this.storageService.getCompanyID();
        if (cachedData && isHardReload) {
            const parsedCacheData = JSON.parse(cachedData);
            const modifiedData = this.handleColumnsSettingResponse(parsedCacheData, pageReference);
            return of(modifiedData);
        } else {
            let obj = {
                "companyId": companyId,
                "userId": userId,
                "page": pageReference,
                "isView": isView,
                "json": jsonColumnDataGet
            }
            const url = 'GetFilterByAdmin'; //`filter?userId=${userId}&page=${pageReference}&companyId=${companyId}&isView=${isView}&jsonColumnDataGet=${jsonColumnDataGet}`;
            return this.http.post(environment.APIURLV2 + url, obj)
                .pipe(
                    map((response: any) => {
                       return this.handleColumnsSettingResponse(response,pageReference);
                    }),
                    catchError(error => of(error))
                );
        }
    }

    handleColumnsSettingResponse(response: any, pageReference: string) {
        var companyNamelocalStorage = localStorage.getItem("companyName");
        let pageReferenceName=pageReference;
        if (response.isDefault === true || response.isDefault === false) {
            this.presetNameArrDefault = []

            let obj1 = {
                presetName: pageReferenceName + ' - ' + companyNamelocalStorage,
                isDefault: response.isDefault

            }
            this.presetNameArrDefault.push(obj1)
            this.columnPresetDefault.next(this.presetNameArrDefault);
            localStorage.setItem('presetNameDefault', JSON.stringify(this.presetNameArrDefault));
        }

        this.presetNameArr = []; // Define arr outside the map loop
        response.tablePresetResponses?.map(x => {
            let obj = { // Define obj inside the map loop
                presetName: x.presetName,
                tableFilterId: x.tableFilterId,
                isDefault: x.isDefault
            };
            this.presetNameArr.push(obj);
            x.isDefault// Push obj to arr within the map loop

        });
        this.columnsData.next(this.presetNameArr);
        localStorage.setItem('presetName', JSON.stringify(this.presetNameArr));
        this.gettingResponse = null;

        if (response.isDefault === true) {
            var presetName = "system preset";
            localStorage.setItem("responsePresetName", JSON.stringify(presetName));
            localStorage.setItem(pageReference + '-' + this.STORAGE_KEY, JSON.stringify(response));

            // var parseData = JSON.parse(response.filterJson)
            var parseData = response.filterJson ? JSON.parse(response.filterJson) : '';

            // parseData.presetName = presetName
            localStorage.setItem(pageReference + "-filterJSON", JSON.stringify(parseData));
            this.gettingResponse = response;

        }
        else {
            response.tablePresetResponses?.map(x => {

                if (x.isDefault === true) {

                    var presetName = x.presetName;
                    localStorage.setItem("responsePresetName", JSON.stringify(presetName));
                    if (presetName !== 'Current Session Preset') {
                        localStorage.setItem(pageReference + '-' + this.STORAGE_KEY, JSON.stringify(response));
                    }
                    // var parseData = JSON.parse(x.filterJson); // Parse the JSON string if it's a string
                    var parseData = x.filterJson ? JSON.parse(x.filterJson) : '';

                    // parseData.presetName = presetName; // Add presetName to the filterJson object

                    // Convert back to a JSON string and set in localStorage
                    localStorage.setItem(pageReference + "-filterJSON", JSON.stringify(parseData));

                    this.gettingResponse = x;

                }
            })
        }
        localStorage.setItem(this.getIsViewKey(pageReference), JSON.stringify(false));
        localStorage.setItem("isViewBool", JSON.stringify(false));
        return this.gettingResponse
    }

    public postTableSettings(tableSettingKey, body): Observable<any> {
        localStorage.removeItem(tableSettingKey + '-' + this.STORAGE_KEY);
        return this.http.post(environment.APIURLV2 + 'filter-admin', body);
    }

    public getLocalTableSettings(tableSettingKey): string {
        return localStorage.getItem(tableSettingKey + '-' + this.STORAGE_KEY);
    }

    public showLoader() {
        this.spinner.show();
    }
    public hideLoader() {
        this.spinner.hide();
    }

    filterDeviceModel(value: string, optionsArr): any[] {
        if (!value) {
            return optionsArr;
        }
        const lowerCaseValue = value.toLowerCase();
        return optionsArr.filter(option => option.deviceType.toLowerCase().includes(lowerCaseValue));
    }
    
    filterOptions(value: string, optionsArr): any[] {
        if (!value) {
            return optionsArr;
        }
        const lowerCaseValue = value.toLowerCase();
        return optionsArr.filter(option => option.name.toLowerCase().includes(lowerCaseValue));
    }

    filterOption(value: string, optionsArr): any[] {
        if (!value) {
            return optionsArr;
        }
        const stringValue = value.toLowerCase();
        return optionsArr.filter(option => option.imei.toLowerCase().includes(stringValue));
    }
    

    downloadTemplate(fileUrl, savedName) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', fileUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (xhr.status === 200) {
                const blob = new Blob([xhr.response], { type: 'application/octet-stream' });
                saveAs(blob, savedName);
            }
        };
        xhr.send();
    }



    // ----------------------------------- Preset API's ----------------------------------


    // New API for enabling preset
    public enablePreset(body): Observable<any> {
        return this.http.post(environment.APIURLV2 + 'tablefilter/enablepreset-admin', body);
    }
    // Check preset name already exists API
    public checkPresetName(body): Observable<any> {
        return this.http.post(environment.APIURLV2 + 'tablefilter/checkpresetname-admin', body);
    }
    // Delete preset API
    public deletePresetRequest(url): Observable<any> {
        return this.http.delete(environment.APIURLV2 + url);
    }
    // Get preset details API for Edit preset
     public getRequestAdmin(URL: any): Observable<any> {
        return this.http.get(environment.APIURLV2 + URL);
    }
}
